import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg',
      name: 'Ibu Sari Dewi',
      location: 'Jakarta Selatan',
      rating: 5,
      text: '"Sapi qurban dari PAK MoO sangat berkualitas. Beratnya sesuai, sehat, dan pelayanannya sangat memuaskan. Pengiriman tepat waktu dan tim sangat profesional."'
    },
    {
      avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg',
      name: 'Bapak Ahmad Rizki',
      location: 'Depok',
      rating: 5,
      text: '"Sudah 3 tahun berturut-turut pesan domba qurban di PAK MoO. Selalu puas dengan kualitas dan pelayanannya. Harga juga sangat kompetitif dibanding tempat lain."'
    },
    {
      avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg',
      name: 'Bapak Eko Prasetyo',
      location: 'Petani Mitra',
      rating: 5,
      text: '"Bergabung dengan PAK MoO sebagai mitra petani sangat menguntungkan. Mereka memberikan pembinaan teknis dan pasar yang jelas untuk hasil panen kami."'
    }
  ];

  return (
    <section id="testimonials" className="pt-20 sm:pt-24 pb-16 sm:pb-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center bg-primary/10 text-primary px-3 py-2 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4">
            <i className="fa-solid fa-quote-left mr-2"></i>
            Testimoni Pelanggan
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6">
            Apa Kata <span className="text-secondary">Pelanggan Kami</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            Kepuasan pelanggan adalah prioritas utama kami. 
            Dengarkan pengalaman langsung dari mereka yang telah mempercayai PAK MoO.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-light-bg rounded-2xl p-6 sm:p-7 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4 sm:mb-6">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-14 h-14 sm:w-16 sm:h-16 rounded-full mr-4" />
                <div>
                  <h4 className="font-bold text-primary text-sm sm:text-base">{testimonial.name}</h4>
                  <p className="text-xs sm:text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
              <div className="flex mb-3 sm:mb-4 text-sm">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star text-accent mr-1"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                {testimonial.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

